import { Checkbox } from '@mui/material'
import useStyles from './useStyles'

function TableHeader ({ toggleAll, allChecked, indeterminate }) {
  const classes = useStyles()
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox />
        </th>
        <th className={classes.headStatus}>Estado</th>
        <th className={classes.headName}>Nombre y Apellido</th>
        <th className={classes.headTypeUser}>Tipo de usuario</th>
        <th className={classes.headTypeComercial}>Tipo comercial</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
